import { Avatar, styled } from '@mui/material';

export const NavListItemAvatarStyled = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  border: isActive ? `2px solid ${theme.palette.success.main}` : undefined,
}));
